import "../../Active.css";
import { jsx } from "react/jsx-runtime";
const base = "Active_base_37cd8";
const dots = "Active_dots_37cd8";
const pulse = "Active_pulse_37cd8";
const css = {
  base,
  dots,
  pulse
};
const Active = () => {
  return /* @__PURE__ */ jsx("div", { className: css.base, children: /* @__PURE__ */ jsx("div", { className: css.dots }) });
};
export {
  Active as default
};
